var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconAvatar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18",
  width: "1em",
  height: "1em"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#icon-avatar_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M9 2c3.86 0 7 3.14 7 7s-3.14 7-7 7-7-3.14-7-7 3.14-7 7-7Zm0-2a9 9 0 1 0 .001 18.001A9 9 0 0 0 9 0Z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeWidth: 2,
  d: "M9 4c1.601 0 3 1.244 3 3.4 0 1.197-.275 2.404-.805 3.275C10.687 11.51 9.98 12 9 12c-.98 0-1.687-.489-2.195-1.325C6.275 9.804 6 8.597 6 7.4 6 5.244 7.399 4 9 4Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "m5.893 11.097-.697.261a3 3 0 0 0-1.347 1.01L2.7 13.9a1 1 0 0 0 1.6 1.2l1.15-1.532a1 1 0 0 1 .448-.337l1.56-.584c-.662-.334-1.18-.882-1.565-1.55Zm4.65 1.55 1.559.584a1 1 0 0 1 .449.337L13.7 15.1a1 1 0 0 0 1.6-1.2l-1.15-1.533a3 3 0 0 0-1.346-1.009l-.697-.26c-.386.667-.903 1.215-1.564 1.549Z",
  clipRule: "evenodd"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "icon-avatar_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h18v18H0z"
})))));
export default SvgIconAvatar;